import { defineStore } from 'pinia'

export const useLogStore = defineStore('log', {
    state: () => ({
        // 日志格式：
        // timestamp: Date.now(), // 时间戳
        // level: 'info', // 日志级别，如 'info', 'error', 'warn'
        // title: '日志标题', // 可选的日志标题
        // message: '日志内容', // 日志内容
        logs: [], // 存储日志的数组
    }),
    actions: {
        addLog(log) {
            log.timestamp = Date.now() // 添加时间戳
            this.logs.push(log) // 将新的日志添加到数组中
        }
    }
})